import api, { v1 } from "../../repositories/API/Axios.api";
import { LanguageItem } from "./interface/LanguageItem";

export const getLanguages = async (route: string) => {
  const response: any = await api
    .get<LanguageItem[]>(v1(route))
    .catch((error) => console.log(error));
  return response?.data;
};
